import Project from "../main.js";
import {Logos} from "../components/logos.js";
import {News} from "../components/news.js";
import {Galleries} from "../components/galleries.js";

export class Homepage {
	constructor() {
		this.project = new Project()

		this.instances = {
			news: new News(),
			galleries: new Galleries(),
			logos: new Logos()
		}
	}
}